import { useEffect, useState } from 'react';
import { supabase } from '../services/supabase';
import { useAuth } from './useAuth';

/**
 * useHasRole - zistí, či má užívateľ požadovanú rolu (alebo viac rolí)
 * @param {string|string[]} allowedRoles - rola alebo pole rolí, ktoré sú povolené
 * @returns { hasRole, isLoading, role }
 */
export function useHasRole(allowedRoles) {
  const { user } = useAuth();
  const [role, setRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRole(null);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', user.id)
      .single()
      .then(({ data, error }) => {
        if (error || !data) {
          setRole(null);
        } else {
          /**
           * Normalizujeme rolu kvôli spätnej kompatibilite so starším označením "super_admin".
           * Frontend pracuje s názvom "admin", preto aliasujeme.
           */
          const normalizedRole = data.role === 'super_admin' ? 'admin' : data.role;
          setRole(normalizedRole);
        }
        setIsLoading(false);
      });
  }, [user]);

  const allowed = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
  const hasRole = role ? allowed.includes(role) : false;

  return { hasRole, isLoading, role };
} 